module.exports = __webpack_public_path__ + "media/images/facilities/speaker-78355e6a224b11d25c19e54cb353422b.png";